/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Created_ColInputs */

const en_admin_tickets_created_col = /** @type {(inputs: Admin_Tickets_Created_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created At`)
};

/**
* | output |
* | --- |
* | "Created At" |
*
* @param {Admin_Tickets_Created_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_created_col = /** @type {((inputs?: Admin_Tickets_Created_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Created_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_created_col(inputs)
});
export { admin_tickets_created_col as "admin.tickets.created_col" }